
export default {
  computed: {
    siteBrand () {
      return this.$store.state.siteBrand
    }
  }
}
